import i18n from "@/i18n/index";
import { QUIZ_CONTENT_CONFIG } from "@/configs/versions/quiz-content";
import { LANDING_CONTENT_CONFIG, LANDINGS_EMAIL_CONTENT } from "@/configs/versions/landing";
import { FINAL_PLAN_CONTENT } from "@/configs/versions/final-plan";
import { FINAL_PAGE_CONTENT } from "@/configs/versions/final-page";
import {HOMEPAGE_CONTENT} from "@/configs/versions/homepage";

export async function loadLazyTextsContent({quiz, landing, upsell, home}, callback) {
  const pathName = window.location.pathname;
  const landingEmailNaming = ['ios_v', 'android_v']
  const landing_email = landingEmailNaming.some(name => pathName.includes(name))
    ? pathName.replace('/', '')
    : LANDINGS_EMAIL_CONTENT.default;

  const locale = i18n.global.locale.value;
  const quizContent = QUIZ_CONTENT_CONFIG[quiz] || QUIZ_CONTENT_CONFIG.default;
  const landingContent = LANDING_CONTENT_CONFIG[landing] || LANDING_CONTENT_CONFIG.default;
  const upsellContent = FINAL_PLAN_CONTENT[upsell] || FINAL_PLAN_CONTENT.default;
  const finalPageContent = FINAL_PAGE_CONTENT[upsell] || FINAL_PAGE_CONTENT.default;
  const homePageContent = HOMEPAGE_CONTENT[home] || HOMEPAGE_CONTENT.default;

  const quizModule = await import(`@/locales/lazy-content/${locale}/quiz/${quizContent}/index.js`);
  const landingModule = await import(`@/locales/lazy-content/${locale}/landing/${landingContent}/index.js`);
  const upsellModule = await import(`@/locales/lazy-content/${locale}/upsell/${upsellContent}/index.js`);
  const finalPageModule = await import(`@/locales/lazy-content/${locale}/final-page/${finalPageContent}/index.js`);
  const homePageModule = await import(`@/locales/lazy-content/${locale}/home-page/${homePageContent}/index.js`);

  let landingEmailContent = landing_email;

  if (landing_email) {
    const landingEmailModule = await import(`@/locales/lazy-content/${locale}/landings-email/${LANDINGS_EMAIL_CONTENT[landing_email.toLowerCase()]}.js`);
    landingEmailContent = landingEmailModule.default;
  }

  const messages = {
    ...i18n.global.messages.value[locale],
    quiz: quizModule.default,
    landing: landingModule.default,
    landing_email: landingEmailContent,
    upsell: upsellModule.default,
    final: finalPageModule.default,
    home: homePageModule.default
  };

  i18n.global.setLocaleMessage(locale, messages)

  callback()
}
